<template>
	<el-switch v-model="option" @change="change" active-color="#13ce66" inactive-color="#ff4949" active-value='1' size="small" inactive-value='0' :disabled='disabled' />
</template>

<script>
	import Vue, { Component } from 'C/BaseVue'
	import { model } from 'service/model'
	import { getConstantByKeyword } from 'service/utils'

	@Component({
		props: [ 'result', 'disabled' ],
		watch: {
			option : {
				handler(curVal, oldVal){
					this.$emit('update:result', curVal)
				}
			},
			result : {
				handler(curVal, oldVal){
					this.option = String(curVal)
				}
			}
		}
	})

	export default class SwitchTabs extends Vue {
		option = ''
		mounted(){
			this.option = this.result
		}

		change(val){
			this.$emit('change',val)
		}
	}

</script>


// WEBPACK FOOTER //
// src/components/SwitchTabs.vue